import type { SideSheetFooterProps } from "./types";

export function SideSheetFooter({
  children,
  className = "",
}: SideSheetFooterProps) {
  return (
    <div
      className={`flex items-center justify-end gap-3 px-6 py-4 bg-surface/80 backdrop-blur-sm shadow-[0_-1px_3px_0_rgba(0,0,0,0.05)] ${className}`}
    >
      {children}
    </div>
  );
}
